import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import NavigationLayout from "../../../Components/NavigationLayout";
import Edit from "./Edit";

const Criterias = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/admin/disorders/criterias" component={List} />
        <Route path="/admin/disorders/criterias/new" component={Add} />
        <Route path="/admin/disorders/criterias/:id" component={Edit} />
      </Switch>
    </Router>
  );
};
export default Criterias;
